<div
	class="row mx-0 sticky-top"
	[attr.id]="stickyContentId"
	[ngStyle]="{ 'top': referenceStickyContentElementOffset + referenceStickyContentElementTopOffset + 'px' }"
>
	<div
		class="col-12 px-0 sticky-wrapper"
		[ngClass]="{
			'is-sticky': createLinkSticked,
			'sticky-background': createLinkSticked && backgroundMode === 'stickyVisible' || backgroundMode === 'visible',
			'sticky-background--transparent': backgroundMode === 'transparent'
		}"
	>
		<ng-content></ng-content>
	</div>
</div>
